export const SHOPPING_CART_FEATURE_KEY = 'shopping-cart';
